import styled from 'styled-components'

const ResponsiveImage = styled.img`
	height: auto;
	vertical-align: middle;
`

export default ResponsiveImage
